import {
  FormField,
  TextField,
  formFieldRequiredLabel as requiredLabel,
} from '@elementary/common-ui/components';
import { useFormContext } from 'react-hook-form';

const BigLakeDataCatalogForm = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <FormField
        title="Connection name"
        errorMessage={errors.bigLakeConnectionName?.message as string}
      >
        <TextField
          {...register('bigLakeConnectionName', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="Connection name"
          size="large"
        />
      </FormField>

      <FormField
        title="Catalog name"
        errorMessage={errors.bigLakeCatalogName?.message as string}
      >
        <TextField
          {...register('bigLakeCatalogName', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="Catalog name"
          size="large"
        />
      </FormField>

      <FormField
        title="GCP project"
        description="Only required when the catalog is in a different GCP project than the connected warehouse."
        optional
        errorMessage={errors.bigLakeProject?.message as string}
      >
        <TextField
          {...register('bigLakeProject')}
          variant="outlined"
          placeholder="GCP project ID"
          size="large"
        />
      </FormField>

      <FormField
        title="Catalog location"
        description="Only required when the BigLake catalog is in a different GCP region than the connected BigQuery dataset."
        optional
        errorMessage={errors.bigLakeCatalogLocation?.message as string}
      >
        <TextField
          {...register('bigLakeCatalogLocation')}
          variant="outlined"
          placeholder="Catalog location"
          size="large"
        />
      </FormField>
    </>
  );
};

export default BigLakeDataCatalogForm;
